import { render } from "./FrontPageAssetStrip.vue?vue&type=template&id=08debfc8&scoped=true"
import script from "./FrontPageAssetStrip.vue?vue&type=script&lang=js"
export * from "./FrontPageAssetStrip.vue?vue&type=script&lang=js"

import "./FrontPageAssetStrip.vue?vue&type=style&index=0&id=08debfc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08debfc8"]])

export default __exports__